import { Deserializable } from '../../interfaces/deserializable';

export class OcrModel implements Deserializable {

	public imageHash: string = null;
	public ocrValue: string = null;

	deserialize(input: any): this {
		Object.getOwnPropertyNames(this).forEach(property => {
			if (input[property] != null && input[property] != undefined) {
				this[property] = input[property];
			}
		});
		return this;
	}
}
